// this files mirrors re_neighborhoods_data.js

const sfarNeighborhoodsList = [
	{ label: 'All Neighborhoods', value: '', key: 'all' },
	{
		label: 'District 1',
		optgroup: true,
		fields: [
			{ label: 'Central Richmond', value: '1A' },
			{ label: 'Inner Richmond', value: '1B' },
			{ label: 'Jordan Park/Laurel Heights', value: '1C' },
			{ label: 'Lake Street', value: '1D' },
			{ label: 'Lone Mountain', value: '1G' },
			{ label: 'Outer Richmond', value: '1E' },
			{ label: 'Sea Cliff', value: '1F' }
		]
	},
	{
		label: 'District 2',
		optgroup: true,
		fields: [
			{ label: 'Central Sunset', value: '2E' },
			{ label: 'Golden Gate Heights', value: '2A' },
			{ label: 'Inner Parkside', value: '2G' },
			{ label: 'Inner Sunset', value: '2F' },
			{ label: 'Outer Parkside', value: '2B' },
			{ label: 'Outer Sunset', value: '2C' },
			{ label: 'Parkside', value: '2D' }
		]
	},
	{
		label: 'District 3',
		optgroup: true,
		fields: [
			{ label: 'Ingleside', value: '3H' },
			{ label: 'Ingleside Heights', value: '3G' },
			{ label: 'Lake Shore', value: '3A' },
			{ label: 'Lakeside', value: '3E' },
			{ label: 'Merced Heights', value: '3B' },
			{ label: 'Merced Manor', value: '3F' },
			{ label: 'Oceanview', value: '3J' },
			{ label: 'Pine Lake Park', value: '3C' },
			{ label: 'Stonestown', value: '3D' }
		]
	},
	{
		label: 'District 4',
		optgroup: true,
		fields: [
			{ label: 'Balboa Terrace', value: '4A' },
			{ label: 'Diamond Heights', value: '4B' },
			{ label: 'Forest Hill', value: '4C' },
			{ label: 'Forest Hill Extension', value: '4J' },
			{ label: 'Forest Knolls', value: '4D' },
			{ label: 'Ingleside Terrace', value: '4E' },
			{ label: 'Midtown Terrace', value: '4F' },
			{ label: 'Miraloma Park', value: '4H' },
			{ label: 'Monterey Heights', value: '4M' },
			{ label: 'Mount Davidson Manor', value: '4N' },
			{ label: 'Sherwood Forest', value: '4K' },
			{ label: 'St. Francis Wood', value: '4G' },
			{ label: 'Sunnyside', value: '4S' },
			{ label: 'West Portal', value: '4T' },
			{ label: 'Westwood Highlands', value: '4P' },
			{ label: 'Westwood Park', value: '4R' }
		]
	},
	{
		label: 'District 5',
		optgroup: true,
		fields: [
			{ label: 'Buena Vista/Ashbury Heights', value: '5F' },
			{ label: 'Clarendon Heights', value: '5H' },
			{ label: 'Cole Valley/Parnassus Heights', value: '5E' },
			{ label: 'Corona Heights', value: '5G' },
			{ label: 'Duboce Triangle', value: '5J' },
			{ label: 'Eureka Valley/Dolores Heights', value: '5K' },
			{ label: 'Glen Park', value: '5A' },
			{ label: 'Haight Ashbury', value: '5B' },
			{ label: 'Mission Dolores', value: '5M' },
			{ label: 'Noe Valley', value: '5C' },
			{ label: 'Twin Peaks', value: '5D' }
		]
	},
	{
		label: 'District 6',
		optgroup: true,
		fields: [
			{ label: 'Alamo Square', value: '6E' },
			{ label: 'Anza Vista', value: '6A' },
			{ label: 'Hayes Valley', value: '6B' },
			{ label: 'Lower Pacific Heights', value: '6C' },
			{ label: 'North Panhandle', value: '6F' },
			{ label: 'Western Addition', value: '6D' }
		]
	},
	{
		label: 'District 7',
		optgroup: true,
		fields: [
			{ label: 'Cow Hollow', value: '7D' },
			{ label: 'Marina', value: '7A' },
			{ label: 'Pacific Heights', value: '7B' },
			{ label: 'Presidio Heights', value: '7C' }
		]
	},
	{
		label: 'District 8',
		optgroup: true,
		fields: [
			{ label: 'Downtown', value: '8A' },
			{ label: 'Financial District/Barbary Coast', value: '8B' },
			{ label: 'Nob Hill', value: '8C' },
			{ label: 'North Beach', value: '8D' },
			{ label: 'North Waterfront', value: '8H' },
			{ label: 'Russian Hill', value: '8E' },
			{ label: 'Telegraph Hill', value: '8G' },
			{ label: 'Tenderloin', value: '8J' },
			{ label: 'Van Ness/Civic Center', value: '8F' }
		]
	},
	{
		label: 'District 9',
		optgroup: true,
		fields: [
			{ label: 'Bernal Heights', value: '9A' },
			{ label: 'Central Waterfront/Dogpatch', value: '9J' },
			{ label: 'Inner Mission', value: '9C' },
			{ label: 'Mission Bay', value: '9D' },
			{ label: 'Potrero Hill', value: '9E' },
			{ label: 'South Beach', value: '9H' },
			{ label: 'South of Market', value: '9F' },
			{ label: 'Yerba Buena', value: '9G' }
		]
	},
	{
		label: 'District 10',
		optgroup: true,
		fields: [
			{ label: 'Bayview', value: '10A' },
			{ label: 'Bayview Heights', value: '10K' },
			{ label: 'Candlestick Point', value: '10M' },
			{ label: 'Crocker Amazon', value: '10B' },
			{ label: 'Excelsior', value: '10C' },
			{ label: 'Hunters Point', value: '10J' },
			{ label: 'Little Hollywood', value: '10N' },
			{ label: 'Mission Terrace', value: '10H' },
			{ label: 'Outer Mission', value: '10D' },
			{ label: 'Portola', value: '10F' },
			{ label: 'Silver Terrace', value: '10G' },
			{ label: 'Visitacion Valley', value: '10E' }
		]
	},
	{ label: 'ALAMEDA', value: 'ALAMEDA' },
	{ label: 'CONTRA COSTA', value: 'CONTRA COSTA' },
	{ label: 'MARIN', value: 'MARIN' },
	{ label: 'NAPA', value: 'NAPA' },
	{ label: 'SAN MATEO', value: 'SAN MATEO' },
	{ label: 'SANTA CLARA', value: 'SANTA CLARA' },
	{ label: 'SOLANO', value: 'SOLANO' },
	{ label: 'SONOMA', value: 'SONOMA' },
	{ label: 'OTHER / Outside the Bay Area', value: 'Other', key:'other' }
];

export default sfarNeighborhoodsList;
